import { Star } from "lucide-react";
import { Reveal } from "./reveal";

const REVIEWS = [
  { name: "Sarah T.", location: "Islington", quote: "Vertex installed three units in our office. Flawless work, tidy engineers." },
  { name: "James M.", location: "Wimbledon", quote: "Called out for an emergency leak. Fixed within the hour. Outstanding service." },
  { name: "David L.", location: "Richmond", quote: "The maintenance plan gives us total peace of mind. Highly recommended." },
];

export function Reviews() {
  return (
    <section id="reviews" className="py-14 lg:py-20 bg-white">
      <div className="container mx-auto max-w-7xl px-4">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="vx-eyebrow text-[hsl(var(--vx-blue))] mb-4">05 — Reviews</p>
            <h2 className="vx-display text-4xl md:text-5xl font-bold text-[hsl(var(--vx-ink))]">What our customers say</h2>
          </div>
          <p className="text-slate-600">Rated <span className="font-semibold text-[hsl(var(--vx-ink))]">4.9</span> from 576 Trustpilot reviews</p>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.08}>
              <figure className={`h-full flex flex-col rounded-[1.75rem] p-8 vx-lift ${i === 1 ? "bg-[hsl(var(--vx-ink))] text-white" : "bg-[hsl(var(--vx-paper))] text-[hsl(var(--vx-ink))]"}`} data-testid={`card-review-${i}`}>
                <div className="flex gap-0.5 text-[hsl(var(--vx-ember))] mb-6" aria-label="Five star review">
                  {Array.from({ length: 5 }).map((_, k) => <Star key={k} className="w-4 h-4 fill-current" aria-hidden="true" />)}
                </div>
                <blockquote className="font-display text-2xl font-semibold leading-snug tracking-tight flex-1">"{r.quote}"</blockquote>
                <figcaption className={`mt-8 flex items-center gap-3 text-sm ${i === 1 ? "text-white/60" : "text-slate-500"}`}>
                  <span className={`grid place-items-center w-9 h-9 rounded-full font-semibold ${i === 1 ? "bg-white/10 text-white" : "bg-white text-[hsl(var(--vx-ink))]"}`}>{r.name[0]}</span>
                  {r.name}, {r.location}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
